export const NotFound = () => {
  return (
    <main id='main-content' className='section-app-content'>
      <div className='app-content'>
        <div className='centered'>
          <h2>Page Not Found</h2>
        </div>
      </div>
    </main>
  );
};
